const PENDING_GITHUB_COMMENT_PREFIX = 'pending:';

export function toPendingGithubCommentId(pendingCommentId: number): string {
  return `${PENDING_GITHUB_COMMENT_PREFIX}${pendingCommentId}`;
}

export function parsePendingGithubCommentId(githubCommentId: string): number | null {
  if (!githubCommentId.startsWith(PENDING_GITHUB_COMMENT_PREFIX)) {
    return null;
  }

  const rawId = githubCommentId.slice(PENDING_GITHUB_COMMENT_PREFIX.length);
  if (!/^\d+$/.test(rawId)) {
    return null;
  }

  const parsed = Number(rawId);
  if (!Number.isSafeInteger(parsed) || parsed <= 0) {
    return null;
  }

  return parsed;
}

export function isPendingGithubCommentId(githubCommentId: string): boolean {
  return parsePendingGithubCommentId(githubCommentId) != null;
}
